module.exports = __webpack_public_path__ + "static/media/down.a4b9b560.svg";